export default __webpack_public_path__ + "static/media/redarrow.2b29c56f.svg";